module.exports = {
      id: "vikatan-tv-usage",
      viewBox: "0 0 213 43",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#vikatan-tv",
      toString: function () {
        return this.url;
      }
    }